
import TWEEN from '@tweenjs/tween.js';

class CounterAnimationClass{
    constructor(){
        this._items = [];
        
    }

    init(){
        Array.from(document.querySelectorAll('.counter-animation')).forEach((element)=>{
            let item = {};
            item.element = element;
            
            let unitMatch = element.textContent.match(/[a-z+\%]+/gi);
            item.unit = unitMatch != null ? unitMatch.join('') : '';
            item.total = element.textContent.match(/[\d\.\,]+/g).join("").replaceAll(',', '');
            item.decimals = item.total % 1 != 0 ? item.total.split('.')[1].length : 0;
            item.disabled = element.classList.contains('counter-animation-disabled');
            item.delay = element.getAttribute('data-counter-animation-delay');
            item.speed = element.getAttribute('data-counter-animation-speed');    
            
            /*console.log('match', unitMatch);
            console.log(item.unit);*/

            element.innerHTML = 0 + item.unit;
            this._items.push(item);
        });

        this._tick();

        this._onScroll();

        document.addEventListener('scroll', this._onScroll.bind(this));
    }

    _onScroll(e = null){
        const items = [...this._items];

        items.forEach((item)=>{
            if(!item.disabled){
                let rect = item.element.getBoundingClientRect();
                
                if(rect.top < window.innerHeight){
                    this._animItem(item);       
                }
            }

        })
    }

    animElement(element){
        for(let item of this._items){
            if(item.element == element){
                this._animItem(item);
                break;
            }
        }
    }

    _animItem(item){
        
        let speed = item.speed || 2000;

        let animation = new TWEEN.Tween({number: 0})
        .to({number: item.total}, speed)
        .onUpdate((obj)=>{
            item.element.innerHTML = obj.number.toFixed(item.decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + item.unit;
        })
        .onComplete(() => {
            
        })
        .easing(TWEEN.Easing.Quadratic.InOut);
        
        if(item.delay){
            animation.delay(parseInt(item.delay, 10));
        }

        animation.start();

        this._items.splice(this._items.indexOf(item), 1);
    }

    _tick(){
        requestAnimationFrame(this._tick.bind(this));

        TWEEN.update();
    }
}

const CounterAnimation = new CounterAnimationClass();
Object.seal(CounterAnimation);

export default CounterAnimation;